<!-- =========== MAIN PAGE CONTAINER ============== -->
<div
	class="main-container"
	[ngStyle]="{
		'background-image': showBackground ? 'url(../../../../assets/images/Trb-latest-svg/Background-img.svg)' : 'none',
	}"
	style="display: flex; flex-direction: column; height: 100%; background-repeat: no-repeat; background-size: cover; background-position: center"
>
	<app-top-navbar [sideBarExpanded]="sideBarExpanded"></app-top-navbar>

	<!-- Content row: body column + chat sidecar (sidecar is here so it only pushes body, not navbar) -->
	<div class="content-row" [class.sidecar-open]="chatSidecarOpen && !chatSidecarFullscreen" [class.sidecar-fullscreen]="chatSidecarFullscreen">
		<div class="body-column">
			<div *ngIf="showBreadcrumb" style="height: 50px; margin: 20px 30px 20px 30px">
				<app-breadcrumb (showHideSpinner)="showHideSpinner($event)"></app-breadcrumb>
			</div>

			<div class="body-container">
				<ngx-spinner [name]="contentContainerSpinner" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
					<p style="color: white">Loading...</p>
				</ngx-spinner>
				<ng-container #dynamicComponent></ng-container>
			</div>

			<!-- ============ FOOTER COMPONENT STYLE ================== -->
			<app-footer></app-footer>
		</div>
		<app-chat-sidecar
			[isOpen]="chatSidecarOpen"
			[isFullscreen]="chatSidecarFullscreen"
			(openChange)="chatSidecarService.setOpen($event)"
			(fullscreenChange)="chatSidecarService.setFullscreen($event)"
		></app-chat-sidecar>
	</div>
</div>
